import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

// Suppress known isChild warning from react-bootstrap
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  const firstArg = typeof args[0] === 'string' ? args[0] : '';
  if (firstArg.includes('isChild') || firstArg.includes('ischild')) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  const firstArg = typeof args[0] === 'string' ? args[0] : '';
  if (firstArg.includes('isChild') || firstArg.includes('ischild')) {
    return;
  }
  originalWarn.apply(console, args);
};

// Also suppress React's internal warnings about unknown props
const originalConsoleError = console.error.bind(console);
console.error = (message, ...args) => {
  if (
    typeof message === 'string' &&
    (message.includes('React does not recognize') || 
     message.includes('isChild'))
  ) {
    return;
  }
  originalConsoleError(message, ...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
